<div class="datepicker">
    <div class="datepicker__input">
        <div class="d-flex align-items-center gap-2">
            <input
                type="text"
                placeholder="dd/mm/yyyy"
                mask="d0/M0/0000"
                [ngModel]="startDate ? formatDate(startDate) : ''"
                (ngModelChange)="onStartDateChange($event)"
                (focus)="isOpen = true" />
            <span>a</span>
            <input
                type="text"
                placeholder="dd/mm/yyyy"
                mask="d0/M0/0000"
                [ngModel]="endDate ? formatDate(endDate) : ''"
                (ngModelChange)="onEndDateChange($event)"
                (focus)="isOpen = true" />
        </div>
        <span class="datepicker__icon" (click)="toggleCalendar()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M3 9.71471C3 9.33236 3.30996 9.0224 3.69231 9.0224H20.3077C20.69 9.0224 21 9.33236 21 9.71471C21 10.0971 20.69 10.407 20.3077 10.407H3.69231C3.30996 10.407 3 10.0971 3 9.71471Z"
                    fill="#4D86BF" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M5.35385 6.02707C4.81099 6.02707 4.38462 6.45998 4.38462 6.9772V17.9268C4.38462 18.444 4.81099 18.8769 5.35385 18.8769H18.6462C19.189 18.8769 19.6154 18.444 19.6154 17.9268V6.9772C19.6154 6.45998 19.189 6.02707 18.6462 6.02707H5.35385ZM3 6.9772C3 5.68023 4.06142 4.64245 5.35385 4.64245H18.6462C19.9386 4.64245 21 5.68023 21 6.9772V17.9268C21 19.2238 19.9386 20.2615 18.6462 20.2615H5.35385C4.06142 20.2615 3 19.2238 3 17.9268V6.9772Z"
                    fill="#4D86BF" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7.56922 3C7.95158 3 8.26153 3.30996 8.26153 3.69231V6.97719C8.26153 7.35954 7.95158 7.6695 7.56922 7.6695C7.18687 7.6695 6.87692 7.35954 6.87692 6.97719V3.69231C6.87692 3.30996 7.18687 3 7.56922 3Z"
                    fill="#4D86BF" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M16.4308 3C16.8131 3 17.1231 3.30996 17.1231 3.69231V6.97719C17.1231 7.35954 16.8131 7.6695 16.4308 7.6695C16.0484 7.6695 15.7385 7.35954 15.7385 6.97719V3.69231C15.7385 3.30996 16.0484 3 16.4308 3Z"
                    fill="#4D86BF" />
            </svg>
        </span>
    </div>

    <div class="datepicker__popup" *ngIf="isOpen"  [ngClass]="{'width-years': activeTab === 'Ano'}">
        <div class="datepicker__tabs">
            <div class="datepicker__tabs-single d-flex align-items-center">
                <button
                class="datepicker__tab"
                [class.active]="activeTab === 'Período'"
                (click)="setActiveTab('Período')">
                Período
            </button>
            <ng-container *ngIf="activeTab === 'Período'">
                <button
                    *ngFor="let option of quickOptions"
                    class="datepicker__quick-tab"
                    [class.selected]="selectedQuickDays === option.days"
                    (click)="selectQuick(option.days)">
                    {{ option.label }}
                </button>
            </ng-container>
            <div class="divider"></div>
            <button
                class="datepicker__tab"
                [class.active]="activeTab === 'Mês'"
                (click)="setActiveTab('Mês')">
                Mês
            </button>
            <div class="divider"></div>
            <button
                class="datepicker__tab"
                [class.active]="activeTab === 'Ano'"
                (click)="setActiveTab('Ano')">
                Ano
            </button>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M3 12C3 7.05 7.05 3 12 3C16.95 3 21 7.05 21 12C21 16.95 16.95 21 12 21C7.05 21 3 16.95 3 12ZM12.0258 9.67287C11.4704 9.67287 11.1001 9.30259 11.1001 8.74716C11.1001 8.19173 11.4704 7.82145 12.0258 7.82145C12.5812 7.82145 12.9515 8.19173 12.9515 8.74716C12.9515 9.30259 12.5812 9.67287 12.0258 9.67287ZM11.1001 15.2272V11.5243C11.1001 11.013 11.5145 10.5986 12.0258 10.5986C12.5371 10.5986 12.9515 11.013 12.9515 11.5243V15.2272C12.9515 15.7384 12.5371 16.1529 12.0258 16.1529C11.5145 16.1529 11.1001 15.7384 11.1001 15.2272Z"
                    fill="#737479" />
            </svg>
        </div>
        <div class="datepicker__body">
            <ng-container *ngIf="activeTab === 'Período'">
                <div class="datepicker__calendar">
                    <bfd-calendar-month
                        [monthBase]="monthBase"
                        [yearBase]="yearBase"
                        [monthOffset]="0"
                        position="left"
                        [selectedStart]="startDate"
                        [selectedEnd]="endDate"
                        [allowFutureDates]="allowFutureDates"
                        (requestPrevMonth)="onPrevMonth()"
                        (requestNextMonth)="onNextMonth()"
                        (requestPrevYear)="onPrevYear()"
                        (requestNextYear)="onNextYear()"
                        (dateClick)="onDateClick($event)">
                    </bfd-calendar-month>

                    <bfd-calendar-month
                        [monthBase]="monthBase"
                        [yearBase]="yearBase"
                        [monthOffset]="1"
                        position="right"
                        [selectedStart]="startDate"
                        [selectedEnd]="endDate"
                        [allowFutureDates]="allowFutureDates"
                        (requestPrevMonth)="onPrevMonth()"
                        (requestNextMonth)="onNextMonth()"
                        (requestPrevYear)="onPrevYear()"
                        (requestNextYear)="onNextYear()"
                        (dateClick)="onDateClick($event)">
                    </bfd-calendar-month>

                </div>

            </ng-container>
            <ng-container *ngIf="activeTab === 'Mês'">
                <div class="datepicker__mes-ano-container">
                    <div class="datepicker__month-col">
                        <div class="datepicker__section-title">Mês</div>
                        <div class="datepicker__month-grid">
                            <div
                                *ngFor="let m of months"
                                class="datepicker__item"
                                [class.selected]="selectedMonth === m.index"
                                (click)="selectMonth(m.index)">
                                {{ m.name }}
                            </div>
                        </div>
                    </div>

                    <div class="datepicker__year-col">
                        <div class="datepicker__section-title">Ano</div>
                        <div class="datepicker__year-grid">
                            <div
                                *ngFor="let y of years"
                                class="datepicker__item"
                                [class.selected]="selectedYear === y"
                                (click)="selectYear(y)">
                                {{ y }}
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="activeTab === 'Ano'">
                <div class="datepicker__ano-container">
                    <div class="datepicker__ano-title">Ano</div>
                    <div class="datepicker__year-grid">
                        <div
                            *ngFor="let y of years"
                            class="datepicker__item"
                            [class.selected]="selectedYear === y"
                            (click)="selectYearOnly(y)">
                            {{ y }}
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<fibra-toast-error-message [color]="typeColorToast"></fibra-toast-error-message>